// Client master — responsible person, expected frequency, status
// Storage is now handled by Supabase (supabase.js)
// This file only contains the update helper and static config

export function updateClient(master, clientName, updates) {
  return { ...master, [clientName]: { ...(master[clientName] || {}), ...updates } };
}

export const TEAM_MEMBERS = [
  'Suchit Sehgal',
  'Operations Team',
  'Sales Team',
  'Finance Team',
];

export const CLIENT_STATUSES = [
  { value: 'active', label: 'Active', color: '#10b981' },
  { value: 'project', label: 'Project-based', color: '#3b82f6' },
  { value: 'dormant', label: 'Dormant', color: '#f59e0b' },
  { value: 'dead', label: 'Closed', color: '#6b7280' },
];

export const FREQUENCY_OPTIONS = [
  { value: 'weekly', label: 'Weekly', days: 7 },
  { value: 'fortnightly', label: 'Fortnightly', days: 14 },
  { value: 'monthly', label: 'Monthly', days: 30 },
  { value: 'quarterly', label: 'Quarterly', days: 90 },
  { value: 'project', label: 'Project-based', days: null },
];
